module.exports = __webpack_public_path__ + "static/img/img4.27cfb494.png";